"use client";

import { useAuth } from "@clerk/nextjs";
import { useTelemetryCaptureEvent } from "@workspace/telemetry/browser";
import { OrgFetchProvider } from "@workspace/ui/org-fetch";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { createOrgFetch } from "./org-fetch";

export function ClerkOrgFetchProvider({ children }: { children: ReactNode }) {
  const { getToken } = useAuth();
  const captureTelemetry = useTelemetryCaptureEvent();
  const orgFetch = useMemo(
    () => createOrgFetch(getToken, undefined, undefined, captureTelemetry),
    [captureTelemetry, getToken],
  );
  return <OrgFetchProvider orgFetch={orgFetch}>{children}</OrgFetchProvider>;
}
